import { Spin } from "antd";
import { motion } from "framer-motion";
import myworkapp_icon from "../../assets/myworkapp-icon.png";

function LogoLoader() {
  return (
    <motion.div
      // initial={{ scale: 0.5, opacity: 0 }}
      animate={{
        // repeatDur: Infinity,
        scale: 1,
        opacity: 1,
        rotate: 360,
      }}
      transition={{
        repeat: Infinity,
        duration: 5,
        ease: "easeOut",
        rotate: { duration: 2, ease: "linear" },
      }}
      className="relative mx-auto h-12 w-12 overflow-hidden"
    >
      <img
        src={myworkapp_icon}
        alt="MyWorkApp Logo"
        className="h-full w-full object-cover"
      />
    </motion.div>
  );
}

export default LogoLoader;
